import { BUILDING_STATUS } from "../constants";
import { InefficientAppliance } from "./buildingMaintance/InefficientAppliance";
import { MaintenanceAlert } from "./buildingMaintance/MaintenanceAlert";
import { MaintenanceRequested } from "./buildingMaintance/MaintenanceRequested";
import { HighestCarbonReduction } from "./emissionImpact/HighestCarbonReduction";
import { HighestCarbonReductionPotential } from "./emissionImpact/HighestCarbonReductionPotential";
import { LowestCarbonReduction } from "./emissionImpact/LowestCarbonReduction";
import { DecreasingConsumptionAlert } from "./leasingOpportunities/DecreasingConsumptionAlert";
import { ExpectedGrowth } from "./leasingOpportunities/ExpectedGrowth";
import { SuspiciousUsage } from "./leasingOpportunities/SuspiciousUsage";
import { BestFitForBatteries } from "./newPowerAsset/BestFitForBatteries";
import { BestFitForEV } from "./newPowerAsset/BestFitForEV";
import { BestFitForSolar } from "./newPowerAsset/BestFitForSolar";
import { UnconnectedTenants } from "./tenancyManagement/UnconnectedTenants";
import { VacancyRate } from "./tenancyManagement/VacancyRate";

const STATUS_COMPONENTS = {
  [BUILDING_STATUS.VACANCY_RATE]: VacancyRate,
  [BUILDING_STATUS.UNCONNECTED_TENANTS]: UnconnectedTenants,
  [BUILDING_STATUS.SHORT_TENANCY_AVG]: VacancyRate,
  [BUILDING_STATUS.RISKY_TENANTS]: UnconnectedTenants,
  [BUILDING_STATUS.EXPECTED_GROWTH]: ExpectedGrowth,
  [BUILDING_STATUS.DECREASING_CONSUMPTION]: DecreasingConsumptionAlert,
  [BUILDING_STATUS.SUSPICIOUS_USAGE_IN_PREMISES]: SuspiciousUsage,
  [BUILDING_STATUS.HIGHEST_CARBON_REDUCTION]: HighestCarbonReduction,
  [BUILDING_STATUS.HIGHEST_CARBON_REDUCTION_POTENTIAL]: HighestCarbonReductionPotential,
  [BUILDING_STATUS.LOWEST_CARBON_REDUCTION]: LowestCarbonReduction,
  [BUILDING_STATUS.BEST_FIT_FOR_BATTERY]: BestFitForBatteries,
  [BUILDING_STATUS.BEST_FIT_FOR_SOLAR]: BestFitForSolar,
  [BUILDING_STATUS.BEST_FIT_FOR_EV]: BestFitForEV,
  [BUILDING_STATUS.INEFFICIENT_APPLIANCE]: InefficientAppliance,
  [BUILDING_STATUS.MAINTENANCE_REQUESTED]: MaintenanceRequested,
  [BUILDING_STATUS.MAINTENANCE_ALERTS]: MaintenanceAlert,
  [BUILDING_STATUS.APPLIANCES_IN_RISK]: MaintenanceAlert,
};

export const BuildingInfo = ({ building, onClose }) => {
  const Component = STATUS_COMPONENTS[building.status];

  return <Component building={building} onClose={onClose} />;
};
